module.exports = __webpack_public_path__ + "static/media/launch.2026a478.png";